import { render, staticRenderFns } from "./subReady.vue?vue&type=template&id=570a5fa8&scoped=true&"
import script from "./subReady.vue?vue&type=script&lang=js&"
export * from "./subReady.vue?vue&type=script&lang=js&"
import style0 from "./subReady.vue?vue&type=style&index=0&id=570a5fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a5fa8",
  null
  
)

export default component.exports